<template>
  <div v-if="isShow">
    <div v-if="isMain">
      <header>
        ひとこと
        <div class="h-left">
          <a  @click="$emit('close')"
            ><img src="~@/assets/images/icon02.svg"
          /></a>
        </div>
      </header>
      <div id="wrap">
        <div class="txt-area">
          <div class="btn4">
            <a  @click="isShowAutoWord = true; isMain = false">例文からひとこと作成</a>
          </div>

          <textarea
            name=""
            class="aword1"
            v-model="formData.mood_status"
            placeholder="ひとことを書く"
          ></textarea>

          <p class="b">書き方でお困りですか？</p>
          <div class="btn4">
            <a  @click="showDemoUserDetail(); isMain = false"
              ><i class="fas fa-user"></i>他の会員のひとことを見る</a
            >
          </div>
        </div>

        <div :class="formData.mood_status ? 'btn1' : 'btn3'">
          <a  @click="$emit('submit', formData)">保存</a>
        </div>
      </div>
    </div>
    <div v-else>
      <autoWord
        :isShow="isShowAutoWord"
        @getValue="getMoodStatus"
        @close="isShowAutoWord = false; isMain = true"
      ></autoWord>
    </div>
  </div>
  <detail v-if="isShowDetail" :idUser="idUser" @close="closeDetail"></detail>
</template>

<script>
import autoWord from "./autoWord"
import { mapGetters } from 'vuex'
import detail from "../../register/component/detail"
import CONSTANTS from "@/constants"
export default {
  components: { autoWord, detail },
  props: {
    isShow: Boolean,
    value: String
  },
  emits: ['close'],
  data: () => ({
    formData: {
      mood_status: null,
    },
    isShowAutoWord: false,
    isMain: true,
    isShowDetail: false,
    idUser: null,
  }),
  mounted() {
      this.formData.mood_status = this.value
  },
  computed: {
      ...mapGetters(['metadata', 'userDetail']),
  },
  watch: {
    isMain() {
      window.scrollTo(0, 0)
    }
  },
  methods: {
    getMoodStatus(value) {
      this.formData.mood_status = value;
      this.isShowAutoWord = false;
      this.isMain = true
    },
    showDemoUserDetail() {
        this.isShowDetail = true
        if (this.userDetail.sex == CONSTANTS.MALE) {
            this.idUser = this.metadata.kara_male;
        } else {
            this.idUser = this.metadata.kara_female;
        }
    },
    closeDetail() {
        this.isShowDetail = false
        this.isMain = true;
    },
  },
};
</script>